export class ReportFiltering {
    // savedReportId: number;
    engagementCode: string;
    engagementName: string;
    engagementDesc: string;
}
export class ReportMainData{
    reportId: number;
    savedReportId: number;
    reportName: string;
    reportCode: string;
    savedReportName: string;
    savedReportFilterParameters: string;
}
export class DeleteSavedFilterDto{
    savedReportId: number;
}

export class DeleteQueueFilterDto{
    queueReportId: number;
}